export { default } from './CookieFooterLink'
